export default "__VITE_ASSET__66abcfb1__"